import { Tag } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { formats } from '../../library/constants/formats.js';
import dayjs from '../../library/utils/dayjs';
import styles from './selected-filters.module.scss';

const formatDay = (value) => (value ? dayjs(value, formats.backendDateFormat).format(formats.frontendDateFormat) : '…')

// Applied-filter chips, like the ERP's SelectedFilters. One chip per filter;
// start_date/end_date share one chip; search stays in the search box. Closing
// a chip removes those filter keys.
const SelectedFilters = ({ filters, dateLabel, statusOptions, onRemove }) => {
    const chips = []
    if (filters?.start_date || filters?.end_date) {
        chips.push({ keys: ['start_date', 'end_date'], text: `${dateLabel}: ${formatDay(filters.start_date)} → ${formatDay(filters.end_date)}` })
    }
    if (filters?.status) {
        const names = String(filters.status).split(',').map((value) => (
            statusOptions.find((option) => String(option.value) === value)?.label ?? value
        ))
        chips.push({ keys: ['status'], text: `Status: ${names.join(', ')}` })
    }
    if (filters?.product_name) {
        chips.push({ keys: ['product_name'], text: `Product: ${filters.product_name}` })
    }
    if (!chips.length) return null
    return chips.map(({ keys, text }) => (
        <Tag key={keys.join()} className={styles.chip} closable onClose={(e) => { e.preventDefault(); onRemove(keys) }}>
            <span className={styles.text}>{text}</span>
        </Tag>
    ))
}

SelectedFilters.propTypes = {
    filters: PropTypes.object,
    dateLabel: PropTypes.string.isRequired,
    statusOptions: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.number, label: PropTypes.string })).isRequired,
    onRemove: PropTypes.func.isRequired,
}

export default SelectedFilters
